enum AccessibleFeature {
  CONVERSIONS_LOG = 'conversionsLog',
  FACEBOOK_ACCOUNTS = 'facebookAccounts',
  FILES = 'files',
}

export default AccessibleFeature;
